import loadable from '@loadable/component';

export const TestimonialsEdit = loadable(
  () => import(/* webpackChunkName: "redturtle__volto-blocks" */ './Edit'),
);
